import {
    Box,
    Button,
    IconButton,
    Text,
    Tooltip,
    useBoolean,
    useOutsideClick
} from '@chakra-ui/react'
import { Icon } from 'components/atoms'
import { FileDeclarationItem } from 'pages/Report/types'
import { useRef } from 'react'

interface FileGeneratorProps {
    callAPI: (file: FileDeclarationItem) => void
    loading: boolean
}

export const FileGeneratorDeclaration = ({
    callAPI,
    loading
}: FileGeneratorProps) => {
    const refTooltip = useRef(null)
    const [tooltipState, setTooltipState] = useBoolean(false)

    useOutsideClick({
        ref: refTooltip,
        handler: setTooltipState.off
    })

    const files: Array<FileDeclarationItem> = [
        {
            text: 'Resumida',
            resumida: true
        },
        {
            text: 'Inteiro Teor',
            resumida: false
        }
    ]

    const downloadFile = (item: FileDeclarationItem) => {
        callAPI(item)
        setTooltipState.off()
    }

    return (
        <>
            <Tooltip
                ref={refTooltip}
                isOpen={tooltipState}
                hasArrow
                placement="bottom-start"
                backgroundColor="none"
                label={
                    <Box
                        bg="white"
                        width="150px"
                        borderRadius="8px"
                        pointerEvents="auto"
                        textAlign="center"
                        paddingY="12px"
                    >
                        <Text
                            fontSize="14px"
                            fontWeight={'bold'}
                            padding="16px 10px"
                            color="black"
                        >
                            Salvar declaração:
                        </Text>

                        {files.map((file, index) => {
                            return (
                                <Button
                                    key={index}
                                    width="100%"
                                    height="32px"
                                    colorScheme="off-white"
                                    color="black"
                                    onClick={() => downloadFile(file)}
                                    isLoading={loading}
                                    _hover={{
                                        background: 'grayscale.50'
                                    }}
                                >
                                    {file.text}
                                </Button>
                            )
                        })}
                    </Box>
                }
            >
                <IconButton
                    data-testid="contract-pdf-btn"
                    colorScheme="primary"
                    onClick={setTooltipState.toggle}
                    color="inherit"
                    aria-label="save"
                    icon={<Icon name="save" size={10.67} />}
                />
            </Tooltip>
        </>
    )
}
